export class Response_1 {
  constructor(
    public cannotBeAssessed: boolean | false,
    public cannotBeAssessedReason: string | null,
    public metNotMetStatus: string | null,
    public isMalariaMandatorily: boolean | null,
    public comments: string | null
  ) {
    this.cannotBeAssessed = cannotBeAssessed;
    this.cannotBeAssessedReason = cannotBeAssessedReason;
    this.metNotMetStatus = metNotMetStatus;
    this.isMalariaMandatorily = isMalariaMandatorily;
    this.comments = comments;
  }
  static init = () => new Response_1(false, null, null, null, null);
}
